export default "__VITE_ASSET__MZh7ixJ9__"